<div class="back h-100 w-100 popup-background overflow-auto flex justify-content-center align-items-center">
  <div #innerPopup class="body background-white border-grey padding-xxl-24">
    <!-- client -->
    <div *ngIf="activeTab === 'Clients' && client" class="w-100 h-100">
      <div class="font--xxl-18 font-500 font-regular color-sky-blue margin-xxl--bottom-40">Create new client</div>
      <div class="flex align-items-start justify-content-start margin-xxl--bottom-32">
        <div (click)="isDomesticLoad = true" class="flex align-items-center margin-xxl--right-24 cursor-pointer">
          <div class="radio border-grey-line margin-xxl--right-12">
            <div
              class="radio-inside"
              [ngClass]="{
                'background-turquoise--dark': isDomesticLoad,
                'background-white': !isDomesticLoad
              }"
            ></div>
          </div>
          <input type="radio" id="post_code" />
          <label
            for="post_code"
            class="font--xxl-12"
            [ngClass]="{
              'color-dark-blue': isDomesticLoad,
              'color-body-text': !isDomesticLoad
            }"
            >Post Code</label
          >
        </div>
        <div (click)="isDomesticLoad = false" class="flex align-items-center cursor-pointer">
          <div class="radio border-grey-line margin-xxl--right-12">
            <div
              class="radio-inside"
              [ngClass]="{
                'background-turquoise--dark': !isDomesticLoad,
                'background-white': isDomesticLoad
              }"
            ></div>
          </div>
          <input type="radio" id="address" /><label
            for="address"
            class="font--xxl-12"
            [ngClass]="{
              'color-dark-blue': !isDomesticLoad,
              'color-body-text': isDomesticLoad
            }"
            >Address</label
          >
        </div>
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Client Name</div>
        <input
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="client.name"
          type="text"
        />
      </div>
      <!-- <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Address</div>
        <app-select-typeahead
          [input_value]="suggestions"
          [exsisting_value]="existingAddress"
          [placeholder]="''"
          [objectKey]="'href'"
          [objectValue]="'title'"
          [inputWidth]="'20'"
          [returnWholeObject]="true"
          (emmiterReturnValue)="getAddress($event, 'address')"
          (emmiterReturnString)="getSuggestions($event)"
          [inputStyle]="'input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular input-border'"
        ></app-select-typeahead>
      </div> -->
      <!-- <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Postal Code</div>
        <app-select-typeahead
          [input_value]="postCodes"
          [exsisting_value]="client.address.postalCode"
          [placeholder]="''"
          [objectKey]="'postalCode'"
          [objectValue]="'postalCode'"
          [inputWidth]="'9'"
          [returnWholeObject]="true"
          (emmiterReturnValue)="getAddress($event, 'postalCode')"
          (emmiterReturnString)="getPostalCodeSuggestions($event)"
          [inputStyle]="'input-large font--xxl-13 color-dark-blue font-regular input-border'"
        ></app-select-typeahead>
      </div> -->
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Postal code</div>
        <!-- app-select-typeahead is deprecated, use app-typeahead instead -->
        <app-select-typeahead
          [input_value]="postCodes"
          [exsisting_value]="client.address.postalCode"
          [placeholder]="''"
          [objectKey]="'postalCode'"
          [objectValue]="'postalCode'"
          [isDisabled]="!isDomesticLoad"
          [inputWidth]="'9'"
          [returnWholeObject]="true"
          (emmiterReturnValue)="getAddress($event, 'postalCode')"
          (emmiterReturnString)="getPostalCodeSuggestions($event)"
          [inputStyle]="
            'input-large font--xxl-13 color-dark-blue font-regular border-grey-bluish ' +
            (!isDomesticLoad ? 'background-background-blue-dark-imp' : '')
          "
        ></app-select-typeahead>
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Address</div>
        <!-- app-select-typeahead is deprecated, use app-typeahead instead -->
        <app-select-typeahead
          appDebounce
          [input_value]="suggestions"
          [exsisting_value]="existingAddress"
          [isDisabled]="isDomesticLoad"
          [placeholder]="''"
          [objectKey]="'href'"
          [objectValue]="'title'"
          [inputWidth]="'20'"
          [returnWholeObject]="true"
          (emmiterReturnValue)="getAddress($event, 'address')"
          (emmiterReturnString)="getSuggestions($event)"
          [inputStyle]="
            'input-large  font--xxl-13 color-dark-blue font-regular border-grey-bluish ' +
            (isDomesticLoad ? 'background-background-blue-dark-imp' : '')
          "
        ></app-select-typeahead>
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Website</div>
        <input
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="client.website"
          type="text"
        />
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Contact person</div>
        <input
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="client.contactPerson"
          type="text"
        />
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Phone number</div>
        <app-phone
          [(ngModel)]="client.phone"
          [valuePlaceholder]="'Phone number'"
          [countries]="countries"
          [objectKey]="'iso3'"
          [objectValue]="'phonecode'"
          [inputHeight]="2.5"
          [inputWidth]="4.5"
          [countryIso]="countryIso?.countryIso"
          [countryIso3]="countryIso?.countryIso3"
          [countryCode]="countryIso?.countryCode"
          [showFlag]="true"
        ></app-phone>
      </div>
      <div class="flex flex-column margin-xxl--bottom-25">
        <div class="font--xxl-11 color-body-text font-regular">Email</div>
        <input
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="client.email"
          type="text"
          autocomplete="new-password"
        />
      </div>
      <div class="popup-box-buttons flex justify-content-end align-items-center">
        <div (click)="closePopup()" class="margin-xxl--right-30 font--xxl-14 color-dark-blue cursor-pointer">
          Cancel
        </div>
        <div
          (click)="saveClient()"
          class="button-round-medium color-dark-blue font--xxl-14 background-turquoise--dark border-z-green margin-xxl--left-18 flex align-items-center justify-content-center"
        >
          Save
        </div>
      </div>
    </div>
    <!-- cargo -->
    <div *ngIf="activeTab === 'Cargo' && load" class="w-100 h-100">
      <div class="font--xxl-18 font-500 font-regular color-sky-blue margin-xxl--bottom-25">
        {{ load.name ? 'Edit Cargo' : 'Add new cargo' }}
      </div>
      <div class="margin-xxl--bottom-16">
        <div style="height: 2.25rem">
          <div
            *ngIf="
              !!load?.loadType &&
              load?.loadType !== LoadTypeEnum.crates &&
              load?.loadType !== LoadTypeEnum.boxes &&
              load?.loadType !== LoadTypeEnum.bags
            "
            class="flex align-items-center margin-xxl--left-0 margin-xxl--right-auto"
          >
            <label for="doubleStacked" class="margin-xxl--bottom-auto margin-xxl--top-auto">
              <div class="cursor-pointer">
                <img
                  *ngIf="!doubleStacked"
                  alt=""
                  class="input_radio"
                  src="../../../../assets/images/icons/radio.svg"
                />
                <img
                  *ngIf="doubleStacked"
                  alt=""
                  class="input_radio"
                  src="../../../../assets/images/icons/radio-active.svg"
                />
              </div>
            </label>
            <input type="radio" id="doubleStacked" (click)="changePieces()" />
            <div
              (click)="changePieces()"
              class="font--xxl-11 color-body-text font-regular margin-xxl--left-10 cursor-pointer"
            >
              Double stacked
            </div>
          </div>
        </div>
        <div class="flex justify-content-between">
          <div class="flex flex-column margin-xxl--bottom-16">
            <div class="font--xxl-11 color-body-text font-regular">Cargo type</div>
            <!-- <input class="input-large font--xxl-13 color-dark-blue font-regular" formControlName="name" type="text" /> -->
            <div class="input-border border-grey-bluish">
              <app-an-select
                [options]="{
                  selectMultiple: false,
                  inputHeight: '2.5',
                  inputWidth: '9.563',
                  filterFields: false,
                  filterFieldResetAfterSelect: false
                }"
                placeholder="Select currency"
                [dropdownList]="loadTypes"
                [(ngModel)]="load.loadType"
                (ngModelChange)="cargoTemplates(load.loadType)"
              >
              </app-an-select>
            </div>
          </div>
          <div class="flex flex-column margin-xxl--bottom-16">
            <div class="font--xxl-11 color-body-text font-regular">Pieces</div>
            <input
              class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular input-width"
              [ngClass]="{ 'border-red-imp': redOutline }"
              [(ngModel)]="load.pieces"
              (ngModelChange)="redOutline = false"
              type="number"
            />
          </div>
        </div>
        <div class="flex justify-content-between">
          <div class="flex flex-column margin-xxl--bottom-16">
            <div class="font--xxl-11 color-body-text font-regular">Cargo width / height / length</div>
            <div class="flex">
              <input
                class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular input-width-small"
                [(ngModel)]="load.measures.width"
                type="number"
              />
              <input
                class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular input-width-small"
                [(ngModel)]="load.measures.height"
                type="number"
              />
              <input
                class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular input-width-small"
                [(ngModel)]="load.measures.length"
                type="number"
              />
            </div>
          </div>
          <div class="flex flex-column margin-xxl--bottom-16">
            <div class="font--xxl-11 color-body-text font-regular">Unit</div>
            <!-- <input class="input-large font--xxl-13 color-dark-blue font-regular" formControlName="name" type="text" /> -->
            <div class="input-border border-grey-bluish">
              <app-an-select
                [options]="{
                  selectMultiple: false,
                  inputHeight: '2.5',
                  inputWidth: '6.125',
                  filterFields: false,
                  filterFieldResetAfterSelect: false
                }"
                placeholder="Select currency"
                [dropdownList]="measureUnits"
                [(ngModel)]="load.measures.unit"
              >
              </app-an-select>
            </div>
          </div>
        </div>

        <div class="flex justify-content-between">
          <div class="flex flex-column margin-xxl--bottom-16">
            <div class="font--xxl-11 color-body-text font-regular">Cargo weight</div>
            <input
              class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular input-width"
              [(ngModel)]="load.weight"
              type="number"
            />
          </div>
          <div class="flex flex-column margin-xxl--bottom-16">
            <div class="font--xxl-11 color-body-text font-regular">Unit</div>
            <!-- <input class="input-large font--xxl-13 color-dark-blue font-regular" formControlName="name" type="text" /> -->
            <div class="input-border">
              <app-an-select
                [options]="{
                  selectMultiple: false,
                  inputHeight: '2.5',
                  inputWidth: '9.563',
                  filterFields: false,
                  filterFieldResetAfterSelect: false
                }"
                placeholder="Select weight unit"
                [dropdownList]="weightUnits"
                [(ngModel)]="load.weightUnit"
              >
              </app-an-select>
            </div>
          </div>
        </div>

        <div class="flex flex-column">
          <div class="font--xxl-11 color-body-text font-regular">Vehicle Requirements</div>
          <div class="input-border border-grey-bluish background-white">
            <app-an-select
              [options]="{
                selectMultiple: true,
                inputHeight: 2.5,
                inputWidth: 19.93,
                filterFields: false,
                filterFieldResetAfterSelect: false,
                useKeyValue: true
              }"
              [objectKey]="'id'"
              [objectValue]="'name'"
              [dropdownList]="vehicleRequirements"
              [(ngModel)]="load.vehicleRequirements"
              [with_checkbox]="true"
              (ngModelChange)="vehicleRequirementsChanges(load.vehicleRequirements)"
            >
            </app-an-select>
          </div>
        </div>
        <div class="flex flex-column margin-xxl--bottom-16">
          <div class="font--xxl-11 color-body-text font-regular">Cargo Name</div>
          <input
            class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
            [(ngModel)]="load.name"
            type="text"
          />
        </div>
      </div>
      <div class="popup-box-buttons flex justify-content-end align-items-center">
        <div (click)="closePopup()" class="margin-xxl--right-30 font--xxl-14 color-dark-blue cursor-pointer">
          Cancel
        </div>
        <div
          (click)="saveCargo()"
          class="button-round-medium color-dark-blue font--xxl-14 background-turquoise--dark border-z-green margin-xxl--left-18 flex align-items-center justify-content-center"
        >
          Save
        </div>
      </div>
    </div>
    <!-- Locations -->
    <div *ngIf="activeTab === 'ClientLocations' && location" class="w-100 h-100">
      <div class="font--xxl-18 font-500 color-sky-blue margin-xxl--bottom-40">
        Add new {{ hasPermissionToSetClientOnLocation ? '"Ship To "' : '' }} Location
      </div>
      <div class="flex align-items-start justify-content-start margin-xxl--bottom-32">
        <div class="flex align-items-center margin-xxl--right-24">
          <div class="radio border-grey-line margin-xxl--right-12 cursor-pointer" (click)="isDomesticLoad = true">
            <div
              class="radio-inside"
              [ngClass]="{
                'background-turquoise--dark': isDomesticLoad,
                'background-white': !isDomesticLoad
              }"
            ></div>
          </div>
          <input type="radio" id="post_code" />
          <label
            for="post_code"
            class="font--xxl-12"
            [ngClass]="{
              'color-dark-blue': isDomesticLoad,
              'color-body-text': !isDomesticLoad
            }"
            >Post Code</label
          >
        </div>
        <div class="flex align-items-center">
          <div class="radio border-grey-line margin-xxl--right-12 cursor-pointer" (click)="isDomesticLoad = false">
            <div
              class="radio-inside"
              [ngClass]="{
                'background-turquoise--dark': !isDomesticLoad,
                'background-white': isDomesticLoad
              }"
            ></div>
          </div>
          <input type="radio" id="address" /><label
            for="address"
            class="font--xxl-12"
            [ngClass]="{
              'color-dark-blue': !isDomesticLoad,
              'color-body-text': isDomesticLoad
            }"
            >Address</label
          >
        </div>
      </div>
      <div *ngIf="hasPermissionToSetClientOnLocation" class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Client Name</div>
        <div class="client-input">
          <input
            class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
            [(ngModel)]="location.client.name"
            (ngModelChange)="findCompanies(location.client.name)"
            type="text"
            autocomplete="new-password"
          />
          <div *ngIf="suggestedClients.length > 0" class="custom-droplist flex border-blue-full-input">
            <div
              #companyDropbox
              class="custom-droplist-wrapper flex flex-column align-items-start justify-content-center"
            >
              <div
                *ngFor="let company of suggestedClients; let last = last"
                class="item flex align-items-center font--xxl-12 font-regular color-grey-tab cursor-pointer"
                [ngClass]="{ 'border--bottom-grey': !last }"
                (click)="selectCompany(company)"
              >
                {{ company?.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Location Name</div>
        <input
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="location.name"
          type="text"
          autocomplete="new-password"
        />
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Postal code</div>
        <app-select-typeahead
          [input_value]="postCodes"
          [exsisting_value]="location.address.postalCode"
          [placeholder]="''"
          [objectKey]="'postalCode'"
          [objectValue]="'postalCode'"
          [isDisabled]="!isDomesticLoad"
          [inputWidth]="'9'"
          [returnWholeObject]="true"
          (emmiterReturnValue)="getAddress($event, 'postalCode')"
          (emmiterReturnString)="getPostalCodeSuggestions($event)"
          [inputStyle]="
            'input-large font--xxl-13 color-dark-blue font-regular border-grey-bluish ' +
            (!isDomesticLoad ? 'background-background-blue-dark-imp' : '')
          "
        ></app-select-typeahead>
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Address</div>
        <app-select-typeahead
          appDebounce
          [input_value]="suggestions"
          [exsisting_value]="existingAddress"
          [isDisabled]="isDomesticLoad"
          [placeholder]="''"
          [objectKey]="'href'"
          [objectValue]="'title'"
          [inputWidth]="'20'"
          [returnWholeObject]="true"
          (emmiterReturnValue)="getAddress($event, 'address')"
          (emmiterReturnString)="getSuggestions($event)"
          [inputStyle]="
            'input-large  font--xxl-13 color-dark-blue font-regular border-grey-bluish ' +
            (isDomesticLoad ? 'background-background-blue-dark-imp' : '')
          "
        ></app-select-typeahead>
      </div>
      <div class="flex flex-column margin-xxl--bottom-16">
        <div class="font--xxl-11 color-body-text font-regular">Exact Address</div>
        <input
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="location.address.note"
          type="text"
        />
      </div>
      <div class="popup-box-buttons flex justify-content-end align-items-center">
        <div (click)="closePopup()" class="margin-xxl--right-30 font--xxl-14 color-dark-blue cursor-pointer">
          Cancel
        </div>
        <div
          (click)="saveShippingLocation()"
          class="button-round-medium color-dark-blue font--xxl-14 background-turquoise--dark border-z-green margin-xxl--left-18 flex align-items-center justify-content-center"
        >
          Save
        </div>
      </div>
    </div>
  </div>
</div>
